/* AUTO-GENERATED — 3 color Pexels photos per new POI (Imperial Cities batch). */

export const EXTRA_POI_IMAGES = {
  "hassan2-mosque": [
    "/api/files/xaluca/external/pexels/2404046-12a5b17e8b61fd36.jpg",
    "/api/files/xaluca/external/pexels/6587480-a5e7a26c3df202b7.jpg",
    "/api/files/xaluca/external/pexels/19657040-a2c04b41ba6d2ec9.jpg",
  ],
  "oudayas": [
    "/api/files/xaluca/external/pexels/30563471-1f8bd0e6fed9b9a7.jpg",
    "/api/files/xaluca/external/pexels/10161576-55b5f39dbf513e2c.jpg",
    "/api/files/xaluca/external/pexels/19084081-d2b9e00ad5fc5c74.jpg",
  ],
  "torre-hassan": [
    "/api/files/xaluca/external/pexels/20580492-7636b7a90bef42d1.jpg",
    "/api/files/xaluca/external/pexels/29804296-86856f3e9e19ebd4.jpg",
    "/api/files/xaluca/external/pexels/30411801-3364542c8682849a.jpg",
  ],
  "mausoleo-mohammed-v": [
    "/api/files/xaluca/external/pexels/10223439-daa34031822a7982.jpg",
    "/api/files/xaluca/external/pexels/31027327-914876e4edb81a17.jpg",
    "/api/files/xaluca/external/pexels/10223422-707f01fed3875edf.jpg",
  ],
  "chellah": [
    "/api/files/xaluca/external/pexels/32173503-e00f91a61eb7007d.jpg",
    "/api/files/xaluca/external/pexels/32086630-a86143478c2665cb.jpg",
    "/api/files/xaluca/external/pexels/32144364-992cb97e3a22efc2.jpg",
  ],
  "bab-al-mansour": [
    "/api/files/xaluca/external/pexels/943527-c333e8083ed9cca2.jpg",
    "/api/files/xaluca/external/pexels/27987051-f51e939543bc58c1.jpg",
    "/api/files/xaluca/external/pexels/2945595-15897ca8d6f92103.jpg",
  ],
  "moulay-ismail-mausoleo": [
    "/api/files/xaluca/external/pexels/30411801-3364542c8682849a.jpg",
    "/api/files/xaluca/external/pexels/6545522-39ec487275e7c7f9.jpg",
    "/api/files/xaluca/external/pexels/35786086-4c914d8a0fe33e65.jpg",
  ],
  "heri-es-souani": [
    "/api/files/xaluca/external/pexels/6545522-39ec487275e7c7f9.jpg",
    "/api/files/xaluca/external/pexels/36782888-d5823a8814bc4307.jpg",
    "/api/files/xaluca/external/pexels/7391598-6056f88e62ae3751.jpg",
  ],
  "habs-qara": [
    "/api/files/xaluca/external/pexels/6545522-39ec487275e7c7f9.jpg",
    "/api/files/xaluca/external/pexels/36782888-d5823a8814bc4307.jpg",
    "/api/files/xaluca/external/pexels/19190884-e4eeba39beb6a4e3.jpg",
  ],
  "medina-fez": [
    "/api/files/xaluca/external/pexels/36782888-d5823a8814bc4307.jpg",
    "/api/files/xaluca/external/pexels/19190884-e4eeba39beb6a4e3.jpg",
    "/api/files/xaluca/external/pexels/36782889-aea777d5a365c262.jpg",
  ],
  "chouara": [
    "/api/files/xaluca/external/pexels/37424066-79ef3c14d87901a7.jpg",
    "/api/files/xaluca/external/pexels/30197051-e3a1d54c23763b7e.jpg",
    "/api/files/xaluca/external/pexels/37424058-99eb94bbc352f100.jpg",
  ],
  "qarawiyyin": [
    "/api/files/xaluca/external/pexels/32880207-dcba9b5510a3edd6.jpg",
    "/api/files/xaluca/external/pexels/30158526-589262c5ffada8d2.jpg",
    "/api/files/xaluca/external/pexels/35024212-7c53900915a25f31.jpg",
  ],
  "cedros-atlas": [
    "/api/files/xaluca/external/pexels/37096592-1eec66b5541cef1d.jpg",
    "/api/files/xaluca/external/pexels/37096595-1396ab31d8235311.jpg",
    "/api/files/xaluca/external/pexels/32817405-d36cb2f18478f246.jpg",
  ],
  "azrou": [
    "/api/files/xaluca/external/pexels/28152720-bdc42b54b53c35ac.jpg",
    "/api/files/xaluca/external/pexels/31148696-508a10387bd2e41f.jpg",
    "/api/files/xaluca/external/pexels/31116860-7985a82725cc8cfd.jpg",
  ],
  "khenifra": [
    "/api/files/xaluca/external/pexels/28152720-bdc42b54b53c35ac.jpg",
    "/api/files/xaluca/external/pexels/6655418-105378095478f3f6.jpg",
    "/api/files/xaluca/external/pexels/1321989-076b83b3e30da120.jpg",
  ],
  "beni-mellal": [
    "/api/files/xaluca/external/pexels/33421278-45fd1c3fa002aca4.jpg",
    "/api/files/xaluca/external/pexels/37684070-2feb2b89c9c47fe2.jpg",
    "/api/files/xaluca/external/pexels/13519910-b004273f83a9ed71.jpg",
  ],
  "jemaa-el-fna": [
    "/api/files/xaluca/external/pexels/37651105-40e3bce17458df50.jpg",
    "/api/files/xaluca/external/pexels/37644991-06951e7dcd488613.jpg",
    "/api/files/xaluca/external/pexels/37651103-bab8cc263b5e7f07.jpg",
  ],
  "medina-marrakech": [
    "/api/files/xaluca/external/pexels/6621125-9f4e1cf5bbd92482.jpg",
    "/api/files/xaluca/external/pexels/15360686-e6fa0e928742e65a.jpg",
    "/api/files/xaluca/external/pexels/22711558-75850aa2da6937fc.jpg",
  ],
  "koutoubia": [
    "/api/files/xaluca/external/pexels/16188292-25bc06f222ab0bd6.jpg",
    "/api/files/xaluca/external/pexels/36595610-296bbf9b773bcc5f.jpg",
    "/api/files/xaluca/external/pexels/50630-7dfe1a3337366551.jpg",
  ],
  "bahia-palace": [
    "/api/files/xaluca/external/pexels/10306569-5ea0354c579be5b6.png",
    "/api/files/xaluca/external/pexels/36599126-80665e24b668a2a3.jpg",
    "/api/files/xaluca/external/pexels/5504460-38be9fc61c4e3caf.jpg",
  ],
  "zocos-marrakech": [
    "/api/files/xaluca/external/pexels/6621125-9f4e1cf5bbd92482.jpg",
    "/api/files/xaluca/external/pexels/22711558-75850aa2da6937fc.jpg",
    "/api/files/xaluca/external/pexels/35513343-d56f58b82dd681b2.jpg",
  ],
  "farmacia-bereber": [
    "/api/files/xaluca/external/pexels/5332489-93406706411c7a8e.jpg",
    "/api/files/xaluca/external/pexels/31653073-394ce04ae5699397.jpg",
    "/api/files/xaluca/external/pexels/18742777-b3e84a97f460d926.jpg",
  ],
  "majorelle": [
    "/api/files/xaluca/external/pexels/5435195-98eb88551340761a.jpg",
    "/api/files/xaluca/external/pexels/15360688-d4bf05544ae2f3b5.jpg",
    "/api/files/xaluca/external/pexels/6301964-6b4bd243f57148ce.jpg",
  ],
  "medina-essaouira": [
    "/api/files/xaluca/external/pexels/9998393-8931f60c39834d15.jpg",
    "/api/files/xaluca/external/pexels/14199922-156ab59b656ad771.jpg",
    "/api/files/xaluca/external/pexels/6664236-b36ebf8f5b8273bf.jpg",
  ],
  "murallas-essaouira": [
    "/api/files/xaluca/external/pexels/15289893-6185df5cf435802e.jpg",
    "/api/files/xaluca/external/pexels/11588733-36fa11c5565088a0.jpg",
    "/api/files/xaluca/external/pexels/10460823-9b9472da4a9d77fd.jpg",
  ],
  "playa-essaouira": [
    "/api/files/xaluca/external/pexels/7835701-e9b0dc1dcedc92a9.jpg",
    "/api/files/xaluca/external/pexels/9726867-b6c87ef860671111.jpg",
    "/api/files/xaluca/external/pexels/33414210-b47adcf0f5fa030a.jpg",
  ],
  "puerto-essaouira": [
    "/api/files/xaluca/external/pexels/6313478-e18c7aa11908e9b9.jpg",
    "/api/files/xaluca/external/pexels/37087948-4b27bddf245a9326.jpg",
    "/api/files/xaluca/external/pexels/9998392-1768ae5563ea3c17.jpg",
  ],
  "skala-essaouira": [
    "/api/files/xaluca/external/pexels/11095599-9908cc3659d63437.jpg",
    "/api/files/xaluca/external/pexels/14199922-156ab59b656ad771.jpg",
    "/api/files/xaluca/external/pexels/15289893-6185df5cf435802e.jpg",
  ],
  "islas-purpurarias": [
    "/api/files/xaluca/external/pexels/35846256-424bb106a684ed07.jpg",
    "/api/files/xaluca/external/pexels/4906497-778be29eab4fb837.jpg",
    "/api/files/xaluca/external/pexels/11482328-7e9ac997bc173bce.jpg",
  ],
  "mdiq": [
    "/api/files/xaluca/external/pexels/9972839-b8b9fddc4436c869.jpg",
    "/api/files/xaluca/external/pexels/13773632-80dea4e8bd4b0342.jpg",
    "/api/files/xaluca/external/pexels/11098055-a42acff21d8aeb51.jpg",
  ],
  "medina-asilah": [
    "/api/files/xaluca/external/pexels/28200308-b2d97ae0df5768cc.jpg",
    "/api/files/xaluca/external/pexels/25254935-0255f52c690b9a8b.jpg",
    "/api/files/xaluca/external/pexels/25254932-c271113bf93298f4.jpg",
  ],
  "murallas-asilah": [
    "/api/files/xaluca/external/pexels/15289893-6185df5cf435802e.jpg",
    "/api/files/xaluca/external/pexels/25254989-11ea8fec302db03d.jpg",
    "/api/files/xaluca/external/pexels/25254935-0255f52c690b9a8b.jpg",
  ],
  "medina-tetuan": [
    "/api/files/xaluca/external/pexels/9433813-51f59ff9c274bd2a.jpg",
    "/api/files/xaluca/external/pexels/9726731-23866f8f872d9517.jpg",
    "/api/files/xaluca/external/pexels/37377719-28dda7e0a443199e.jpg",
  ],
  "monumentos-aleman": [
    "/api/files/xaluca/external/pexels/37377719-28dda7e0a443199e.jpg",
    "/api/files/xaluca/external/pexels/9433813-51f59ff9c274bd2a.jpg",
    "/api/files/xaluca/external/pexels/9726731-23866f8f872d9517.jpg",
  ],
  "uta-hammam": [
    "/api/files/xaluca/external/pexels/3049885-4ddf7ed30d335c54.jpg",
    "/api/files/xaluca/external/pexels/27465667-24c50b750aade625.jpg",
    "/api/files/xaluca/external/pexels/5472518-e504facb22afc375.jpg",
  ],
  "ras-el-maa": [
    "/api/files/xaluca/external/pexels/333826-c7b00d9238e5a70c.jpg",
    "/api/files/xaluca/external/pexels/35356253-ae9a91e816be0fd5.jpg",
    "/api/files/xaluca/external/pexels/11959107-4dc45137fd85ad50.jpg",
  ],
  "saghro": [
    "/api/files/xaluca/external/pexels/37684102-ceb6730c5604cafb.jpg",
    "/api/files/xaluca/external/pexels/29595717-16ee9ac2fd91ab4a.jpg",
    "/api/files/xaluca/external/pexels/30855641-4e1d5cf067400c06.jpg",
  ],
  "nkob": [
    "/api/files/xaluca/external/pexels/37684084-24dd1cc397007995.jpg",
    "/api/files/xaluca/external/pexels/5504504-96384cd95a243c1c.jpg",
    "/api/files/xaluca/external/pexels/5504563-e8d0050a342d61f5.jpg",
  ],
  "tafraoute": [
    "/api/files/xaluca/external/pexels/35904148-27cea4ddde42fd6f.jpg",
    "/api/files/xaluca/external/pexels/6741117-32bebe99f0f7a2aa.jpg",
    "/api/files/xaluca/external/pexels/6740177-b857683bb9227311.jpg",
  ],
  "aknioun": [
    "/api/files/xaluca/external/pexels/37684102-ceb6730c5604cafb.jpg",
    "/api/files/xaluca/external/pexels/29595719-b5850a061366061a.jpg",
    "/api/files/xaluca/external/pexels/37684067-7517832a9513e344.jpg",
  ],
  "amskar": [
    "/api/files/xaluca/external/pexels/37684079-fe241a60de43c97e.jpg",
    "/api/files/xaluca/external/pexels/28124160-e9e942cb422549a7.jpg",
    "/api/files/xaluca/external/pexels/8571115-4bace252ebc984c5.jpg",
  ],
  "tisserdimine": [
    "/api/files/xaluca/external/pexels/29595719-b5850a061366061a.jpg",
    "/api/files/xaluca/external/pexels/18742776-be17078c30740b99.jpg",
    "/api/files/xaluca/external/pexels/6095564-4e2e9894d3de1979.jpg",
  ],
  "rekam": [
    "/api/files/xaluca/external/pexels/4480900-a0b7acc7b217c77c.jpg",
    "/api/files/xaluca/external/pexels/4694737-e9ac53cdf746ee09.jpg",
    "/api/files/xaluca/external/pexels/29762263-9a97f9ffb776402d.jpg",
  ],
  "oued-remlia": [
    "/api/files/xaluca/external/pexels/35838396-f34ef756dd93ed2e.jpg",
    "/api/files/xaluca/external/pexels/35838231-dcc52f405b86493c.jpg",
    "/api/files/xaluca/external/pexels/35843152-260542368665ab08.jpg",
  ],
  "ouzina": [
    "/api/files/xaluca/external/pexels/10790260-08e56c9010f8a0bb.jpg",
    "/api/files/xaluca/external/pexels/6356195-5066201efc3cd681.jpg",
    "/api/files/xaluca/external/pexels/32825864-ff46a30a3cd76d30.jpg",
  ],
  "minas-mfis": [
    "/api/files/xaluca/external/pexels/17444741-77c77f96a7391de9.jpg",
    "/api/files/xaluca/external/pexels/29389505-9e5f5e45b71af988.jpg",
    "/api/files/xaluca/external/pexels/12105318-03ab141f79ebab90.jpg",
  ],
  "fezzou": [
    "/api/files/xaluca/external/pexels/18742776-be17078c30740b99.jpg",
    "/api/files/xaluca/external/pexels/37684113-3b9cd3709886ab7b.jpg",
    "/api/files/xaluca/external/pexels/5504504-96384cd95a243c1c.jpg",
  ],
  "oasis-fezzou": [
    "/api/files/xaluca/external/pexels/36955401-97ca9cf64b7cc5c9.jpg",
    "/api/files/xaluca/external/pexels/30544112-a65bb555db725259.jpg",
    "/api/files/xaluca/external/pexels/8571115-4bace252ebc984c5.jpg",
  ],
  "pozos-jorf": [
    "/api/files/xaluca/external/pexels/17399217-96e08bdfa902087b.jpg",
    "/api/files/xaluca/external/pexels/10790260-08e56c9010f8a0bb.jpg",
    "/api/files/xaluca/external/pexels/37684092-23f0a538f8013afc.jpg",
  ],
  "chott-merzouga": [
    "/api/files/xaluca/external/pexels/32465104-d2f538192c428b88.jpg",
    "/api/files/xaluca/external/pexels/18127103-95d1b03c089bb32b.jpg",
    "/api/files/xaluca/external/pexels/28556039-5ca4aa8bb5ddbbaa.jpg",
  ],
  "chott-maider": [
    "/api/files/xaluca/external/pexels/29752595-19c5b5ec3d33b5ae.jpg",
    "/api/files/xaluca/external/pexels/8833667-bcdbe98760daadac.jpg",
    "/api/files/xaluca/external/pexels/18642592-94ac28fcbc9ca4b8.jpg",
  ],
  "mercado-rissani": [
    "/api/files/xaluca/external/pexels/35513343-d56f58b82dd681b2.jpg",
    "/api/files/xaluca/external/pexels/35056848-e738e5f1220544cb.jpg",
    "/api/files/xaluca/external/pexels/23730055-b0ba21cbcddf826d.jpg",
  ],
  "mirador-dades": [
    "/api/files/xaluca/external/pexels/14145715-99f658a541a0087e.jpg",
    "/api/files/xaluca/external/pexels/33898633-cf289c1ea3a80cc6.jpg",
    "/api/files/xaluca/external/pexels/33898629-4ed28dc4bcefcccc.jpg",
  ],
  "valle-dades": [
    "/api/files/xaluca/external/pexels/37441764-75da25557655c494.jpg",
    "/api/files/xaluca/external/pexels/34100472-3c4e40a5d7b06afe.jpg",
    "/api/files/xaluca/external/pexels/14145715-99f658a541a0087e.jpg",
  ],
  "gargantas-mgoun": [
    "/api/files/xaluca/external/pexels/14145715-99f658a541a0087e.jpg",
    "/api/files/xaluca/external/pexels/17492446-4adc7fbd9268f919.jpg",
    "/api/files/xaluca/external/pexels/33898633-cf289c1ea3a80cc6.jpg",
  ],
  "atlas-studios": [
    "/api/files/xaluca/external/pexels/19281432-020305c51ba721e9.jpg",
    "/api/files/xaluca/external/pexels/7391866-96d2e8804a7ba8a5.jpg",
    "/api/files/xaluca/external/pexels/7391588-b94a0e7c10aa76f4.jpg",
  ],
  "kasbah-taourirt": [
    "/api/files/xaluca/external/pexels/17399231-95202abdb1f7f4bf.jpg",
    "/api/files/xaluca/external/pexels/943510-6955e64b50254ecc.jpg",
    "/api/files/xaluca/external/pexels/5504555-24716a0fe24ab2c5.jpg",
  ],
  "kasbah-meteorite": [
    "/api/files/xaluca/external/pexels/37684084-24dd1cc397007995.jpg",
    "/api/files/xaluca/external/pexels/5224213-3c1bf38a50292685.jpg",
    "/api/files/xaluca/external/pexels/10790260-08e56c9010f8a0bb.jpg",
  ],
  "tizi-ntichka": [
    "/api/files/xaluca/external/pexels/37672148-98d4c1d4d9f65406.jpg",
    "/api/files/xaluca/external/pexels/21998526-f231114eb86a55b3.jpg",
    "/api/files/xaluca/external/pexels/30254940-02034a4ebe423f33.jpg",
  ],
  "parque-khenifra": [
    "/api/files/xaluca/external/pexels/34100474-2e91aa2f96336463.jpg",
    "/api/files/xaluca/external/pexels/37672157-d62df37e4948d159.jpg",
    "/api/files/xaluca/external/pexels/37891758-d9aaa8f19aacc45d.jpg",
  ],
};

export default EXTRA_POI_IMAGES;
